__turbopack_context__.v({
  "bottom": "STDrawer-module__OdKm3G__bottom",
  "closeBtn": "STDrawer-module__OdKm3G__closeBtn",
  "content": "STDrawer-module__OdKm3G__content",
  "drawer": "STDrawer-module__OdKm3G__drawer",
  "header": "STDrawer-module__OdKm3G__header",
  "left": "STDrawer-module__OdKm3G__left",
  "open": "STDrawer-module__OdKm3G__open",
  "overlay": "STDrawer-module__OdKm3G__overlay",
  "right": "STDrawer-module__OdKm3G__right",
  "show": "STDrawer-module__OdKm3G__show",
  "top": "STDrawer-module__OdKm3G__top",
});
